<template>
  <div class="pages">
    <div class="login-image">
      <img src="../images/login.png" id="img" />
    </div>
    <div class="w3ls-login box box--big center_all">
      <div class="login-title">DxAI 智医-报告解读工具后台管理</div>
      <form autocomplete="on">
        <div class="agile-field-txt">
          <div>
            <i class="fa fa-user" aria-hidden="true"></i>
          </div>
          <input
            type="text"
            v-model="username"
            placeholder="输入你的用户名"
            required=""
            id="username"
          />
        </div>
        <div class="agile-field-txt">
          <div>
            <i class="fa fa-envelope" aria-hidden="true"></i>
          </div>
          <input
            type="password"
            v-model="password"
            placeholder="输入你的密码 "
            required=""
            id="password"
          />
          <div @click.stop="show_password">
            <i
              v-if="is_show_password"
              class="fa fa-eye"
              style="color: #7f7f7f"
              aria-hidden="true"
            ></i>
            <i
              v-else
              class="fa fa-eye-slash"
              style="color: #7f7f7f"
              aria-hidden="true"
            ></i>
          </div>
        </div>
      </form>
      <div class="w3ls-bot">
        <div class="form-end">
          <input
            type="submit"
            :value="loginText"
            class="submit"
            @click="login"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import api from "@/api/index";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      state: true, //没用
      username: "",
      loginText: "登录",
    };
  },
  methods: {
    show_password() {
      const x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
        this.is_show_password = true;
      } else {
        x.type = "password";
        this.is_show_password = false;
      }
    },
    login() {
      this.loginText = "登录中...";
      axios({
        method: "post",
        url: "/api/admin/login",
        data: {
          username: this.username,
          password: this.password,
        },
        headers: { "Content-Type": "application/json" },
      }).then((res) => {

        const { data } = res;
        if (data["code"] === 200) {
          this.getUserInfo();
          //   this.$message.success("登录成功");
          //   router.push("/bec/static");
        } else if (data["code"] === 500) {
          this.$message.error(data["error"]);
        } else {
          this.$message.error("网络异常，请稍后再试！");
        }
      });
    },
    getUserInfo() {
      api.chat.userDetail().then((res) => {
        this.user_info = res.info;
        localStorage.setItem("userinfo", JSON.stringify(res.info));
        this.set_model_ids(res.info);
        this.$message.success("登录成功");
        router.push("/bec/static");
        // if (res.code == 200) {
        //   this.set_model_ids(res.info);
        // }
      });
    },
    ...mapMutations("user", ["set_model_ids"]),
  },
};
</script>

<style lang="scss" scoped>
.login-image {
  display: flex;
  justify-content: center;

  img {
    margin-top: 210px;
    margin-right: 20px;
    width: 485px;
    height: 375px;
    margin-left: -360px;
  }
}

/* @import "../assets/css/font-awesome.css"; */
@import "../assets/style/css/font-awesome.css";

.pages {
  width: 1920px;
  height: 950px;
  background: linear-gradient(90deg, #983cc9, #601e9f, #2e037a);
  display: flex;
  justify-content: center;
}

.w3ls-login {
  transform: translateY(140px) translateX(100px) !important;
}

* {
  margin: 0;
  padding: 0;
  border: 0;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

ol,
ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

a {
  text-decoration: none;
}

nav.vertical ul li {
  display: block;
}

nav.horizontal ul li {
  display: inline-block;
}

body {
  font-family: "Poppins", sans-serif;
  font-size: 100%;
  background: url(../images/login.png) no-repeat center top;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  background-attachment: fixed;
  text-align: center;
}

h1 {
  font-size: 3.2em;
  text-transform: capitalize;
  color: #fff;
  text-shadow: 1px 1px 1px #000;
  letter-spacing: 3px;
  margin: 0.8em 1vw;
  text-align: center;
}

.w3ls-login label {
  font-size: 14px;
  float: left;
  text-align: left;
  margin-bottom: 5px;
  text-transform: capitalize;
  letter-spacing: 2px;
  cursor: pointer;
}

.w3ls-login input[type="text"],
.w3ls-login input[type="password"] {
  width: 100%;
  color: #333;
  outline: none;
  font-size: 15px;
  letter-spacing: 1px;
  border-radius: 8px;
  padding: 15px;
  box-sizing: border-box;
  border: none;
  -webkit-appearance: none;
  background: #fff;
  font-family: "Poppins", sans-serif;
}

label.check {
  float: none;
}

.agile_label {
  text-align: left;
  margin: 10px 0 0;
}

.w3ls-login input[type="submit"] {
  width: 100%;
  padding: 0.5em 0;
  font-size: 1.6em;
  letter-spacing: 2px;
  cursor: pointer;
  border-radius: 20px;
  border: 2px solid #983cc9;
  background-color: #983cc9;
  color: #fff;
  margin-top: 1em;
  outline: none;
  transition: 0.5s all ease;
  -webkit-transition: 0.5s all ease;
  -moz-transition: 0.5s all ease;
  -o-transition: 0.5s all ease;
  -ms-transition: 0.5s all ease;
  font-family: "Poppins", sans-serif;
}

.w3ls-login input[type="submit"]:hover {
  background: transparent;
  border: 2px solid #262424;
  color: #a19c9c;
}

.w3ls-bot {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
}

.switch input {
  display: none;
}

.form-end {
  width: 100%;
}

.copy-wthree p {
  color: #fff;
  font-size: 15px;
  letter-spacing: 1px;
  line-height: 1.8;
  margin: 0 3vw;
}

.copy-wthree p a {
  color: #fd5c63;
  transition: 0.5s all ease;
  -webkit-transition: 0.5s all ease;
  -moz-transition: 0.5s all ease;
  -o-transition: 0.5s all ease;
  -ms-transition: 0.5s all ease;
}

.copy-wthree p a:hover {
  color: #fff;
}

body,
html {
  width: 100%;
  height: 100%;
}

.center_all {
  text-align: center;
}

.w3ls-login {
  width: 30%;
  height: 45%;
  border-radius: 30px;
  padding: 50px;
  border: 5px solid #ffffff;
  box-sizing: border-box;
  display: flex;
  background: white;
  max-width: none;
  flex-direction: column;
  justify-content: center;
}

.agile-field-txt {
  margin-bottom: 15px;
  display: flex;
  border-radius: 20px;
  border: 1px solid #d7d3d3;
  padding: 5px;
}

.agile-field-txt > div {
  width: calc(50px - 5px);
  height: calc(50px - 5px);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}

.agile-field-txt > div > i {
  margin-top: 2.5px;
  color: #983cc9;
}

.w3ls-bot {
  width: 100%;
}

// #img {
//   position: absolute;
//   left: 18%;
//   top: 50%;
//   transform: translate(-10%, -50%);
//   width: 750px;
//   height: 590px;
// }

.title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.title > span {
  color: #3a8ee6;
  cursor: pointer;
  display: none;
}

.title > h2 {
  color: #983cc9;
  font-size: 40px;
}

.login-title {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 30px;
  text-align: center;
  letter-spacing: 1px;

  &::after {
    content: "";
    display: block;
    width: 50px;
    height: 3px;
    /* background: #409eff; */
    margin: 10px auto 0;
  }
}
</style>
